module.exports = __webpack_public_path__ + "static/media/maui.3afc3489.bin";